import View from '../../../controls/View.js';
import Vue from 'vue';
import importUsersApp from './UsersImport.vue';

const UsersImportPage = View.extend({

    className: 'main-body',

    initialize: function (options) {

        this.options = options = options || {};

        this.vueApp = new Vue({
            data: options,
            render: function (h) {
                return h(importUsersApp)
            }
        });

        this.vueApp.$mount();
        this.$el.append(this.vueApp.$el);

        return this;

    },

    remove: function () {

        this.vueApp.$destroy();

        UsersImportPage.__super__.remove.apply(this, arguments);
    }


});

export default UsersImportPage;
